import {
  FormControl,
  FormItem,
  FormMessage
} from "@watt/ui/components/ui/form";
import { Input } from "@watt/ui/components/ui/input";
import AutoFormLabel from "../common/label";
import AutoFormTooltip from "../common/tooltip";
import type { AutoFormInputComponentProps } from "../utils/types";

export default function AutoFormNumber({
  label,
  isRequired,
  fieldConfigItem,
  fieldProps
}: AutoFormInputComponentProps) {
  const { showLabel: _showLabel, ...fieldPropsWithoutShowLabel } = fieldProps;
  const showLabel = _showLabel === undefined ? true : _showLabel;

  return (
    <FormItem>
      {showLabel && (
        <AutoFormLabel
          isRequired={isRequired}
          label={fieldConfigItem?.label || label}
        />
      )}
      <FormControl>
        <Input type="number" {...fieldPropsWithoutShowLabel} />
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
      <FormMessage />
    </FormItem>
  );
}
